// extracted by css-extract-rspack-plugin
export default {"container":"src-app-pages-install-site-Process-Process-module__container-L8bmJx","yet":"src-app-pages-install-site-Process-Process-module__yet-hJMUy1","alert":"src-app-pages-install-site-Process-Process-module__alert-O_59yh"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-app-pages-install-site-Process-Process-module__container-L8bmJx\",\"yet\":\"src-app-pages-install-site-Process-Process-module__yet-hJMUy1\",\"alert\":\"src-app-pages-install-site-Process-Process-module__alert-O_59yh\"}";
        // 1789362523038
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  